<script lang="ts" context="module">
    import { writable } from "svelte/store"
    import {
        highlighters,
        selectedHighlighter,
        changeSelected,
    } from "@store/highlights"
    import { darkmode } from "@utils/material/darkmode"

    export const location = writable({ x: 0, y: 0 })
    export const open = writable(false)
</script>

<script lang="ts">
    let container: HTMLElement

    function placesFromCenter(number: number, total: number) {
        const totalCircle = Math.PI * 2
        const oneSlice = totalCircle / total
        const angleStart = 0
        const radius = 40

        const angle = angleStart + oneSlice * number
        let originX = radius * Math.cos(angle)
        let originY = radius * Math.sin(angle)

        return `translate: ${originX}px ${originY}px`
    }

</script>

<div
    bind:this={container}
    style:translate={`${$location.x}px ${$location.y}px`}
    class="highlightExpandContainer"
    class:closed={!$open}
>
    <div
        class="selectedHighlighterText"
        class:hidden={!$highlighters.get($selectedHighlighter)?.label.length}
    >
        <div>
            <span style:background={$highlighters.get($selectedHighlighter)?.[$darkmode ? "dark" : "light"]}
                >{$highlighters.get($selectedHighlighter)?.label}</span
            >
        </div>
    </div>
    <div class="bubbleBackground" />
    {#each [...$highlighters.values()] as { id }, indexID}
        <div
            class="subColor"
            style={placesFromCenter(indexID, $highlighters.size)}
        >
            <div
                class="highlightSelectorBubble overColor" style:background={$highlighters.get(id)?.[$darkmode ? "dark" : "light"]}
                data-colorid={id}
            />
            <div
                class="highlightSelectorBubble selectableColor"
                style:background={$highlighters.get(id)?.[$darkmode ? "dark" : "light"]}
                data-colorid={id}
            />
        </div>
    {/each}
</div>

<style>
.highlightExpandContainer {
  position: absolute;
  transform-origin: center;
  z-index: 30;
  transform: translate(2px, 3px);
  transition-property: opacity;
}
.highlightExpandContainer.closed {
  pointer-events: none;
  transition-delay: 0.2s;
  opacity: 0;
}
.highlightExpandContainer.closed .selectedHighlighterText {
  opacity: 0;
  top: 0;
  transition: opacity 0.1s linear, top 0.2s ease-in;
}
.highlightExpandContainer.closed .subColor {
  translate: 0 0 !important;
}
.highlightExpandContainer .selectedHighlighterText {
  position: absolute;
  left: -4rem;
  top: -5.4rem;
  width: 10rem;
  z-index: -1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s linear 0.2s, top 0.2s ease-out 0.2s;
}
.highlightExpandContainer .selectedHighlighterText.hidden {
  display: none;
}
.highlightExpandContainer .selectedHighlighterText div {
  background-color: white;
  width: max-content;
  border-radius: 0.5rem;
}
.highlightExpandContainer .selectedHighlighterText div span {
  display: block;
  border-radius: 0.5rem;
  padding: 0.5rem;
}
.highlightExpandContainer .bubbleBackground {
  z-index: -1;
}
.highlightExpandContainer .subColor {
  z-index: -1;
  transition: translate 0.1s linear;
}
.highlightExpandContainer .topHighlighterColor {
  z-index: 10;
}
</style>
